import {useState,useEffect, useContext} from 'react';
import * as React from 'react';
import { Container, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Categoria, GuardarCategoria, ProductoEsperado, Producto_Esperado, getProductoVacio, objProductoEsperado } from '../../../interfaces/Sistema';
import AlertService from '../../../services/AlertService';
import CertificadoService from '../../../services/CertificadoService';
import UsuarioService from '../../../services/UsuarioService';
import CatalogService from '../../../services/CatalogService';
import { CasUserContext, useCasUserContext } from '../../../services/casUserContext';
import IngresoProductoEsperado from './IngresoProductoEsperado';
import ProductoService from '../../../services/ProductoService';

const alertaService = new AlertService();
const catalogoService = new CatalogService();
const productoService = new ProductoService();

interface opcion{
    value:string,
    label: string,
}

interface MiModalProps {
    isOpen: boolean;
    toggle: () => void;
    data: number | undefined;
}


export const ModalEditarProductoEsperado: React.FC<MiModalProps> = ({ isOpen, toggle, data})=>{
    const[ready,SetReady] = useState(false);
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const token = casUserContext.token;
    const categoriasOpcion:Array<opcion>= Array<opcion>()
    const [categoriasActivas,setCategoriasActivas] = useState<Array<Categoria>>([]);
    const [productosActivos,setProductosActivos] = useState<Array<ProductoEsperado>>([]) ;
    const [productoFull, setProductoFull]= useState<objProductoEsperado>(()=>getProductoVacio())
    
    const fetchData = async () =>{
        try{
            //alertaService.showLoading("Cargando Datos..."); 
            await catalogoService.GetCategoriasActivas() 
            .then((data)=>{
                if(data.status.isSuccessfully){
                    setCategoriasActivas(data.listData.reverse())
                    SetReady(true)
                }
            }) 
            .catch((error) => console.error(error)); 
            
            await productoService.GetProductoEsperadoById(data!=undefined ? data:-1,token)
            .then((data)=>{
                if(data.status.messages){
                    let prod:Producto_Esperado={
                        producto: data.data.nombreProducto,
                        categoria: data.data.idCategoria.toString(),
                        activo: data.data.activo.toString()
                    }

                    let idprod= data.data.idProducto

                    let prodEsperado: objProductoEsperado={
                        producto: prod,
                        idprodesp: idprod
                    }
                    setProductoFull(prodEsperado)
                    
                }
            })
            //alertaService.hideLoading();  

                            
        }catch(error){
          console.error('Error:',error);
        }
      };

    categoriasActivas.map((row)=>{
        let opc : opcion={
            value: row.iddecinvcategoria.toString(),
            label: row.nombrecategoria
        }
        if(opc.value!='0'){
            categoriasOpcion.push(opc)
        }
    })
        
    useEffect(() => {
        fetchData();
        },[data]);
    
    if(!ready || !(productoFull.idprodesp===data) ){
    return <Spinner
    color="primary"
    style={{
    height: '3rem',
    width: '3rem'
    }}
    >
    Loading...
    </Spinner>; // Mostrar un indicador de carga mientras se obtienen los datos
    }
    return(
        <Modal className='modal-lg' isOpen={isOpen} toggle={toggle} >
            <ModalHeader>Editar tipo Producto Esperado</ModalHeader>
            <ModalBody style={{padding:'20px'}}>
                <IngresoProductoEsperado productoEsperado={productoFull} categorias={categoriasOpcion} />
            </ModalBody>
        </Modal>
    )
}



